import React from "react";
import circle1 from "../assets/images/footer/shape-1.svg";
import vultusHome from "../assets/images/vultus14.png";
import vultusLogoLight from "../assets/images/Vultus_(13).png";
import vultusLogoDark from "../assets/images/logo/vultus-logo-blue.png";

const Contact = () => {
  return (
    <section id="contact" className="relative py-20 md:py-[120px]">
      <div className="absolute top-0 left-0 z-[-1] h-1/2 w-full  contact-bg lg:h-[45%] xl:h-1/2">
        <span className=" z-[-2] opacity-70 ">
          <img
            src={vultusHome}
            alt="hero"
            className="mx-auto max-w-full rounded-t-xl rounded-tr-xl sm:hidden xs:hidden lg:block xl:block md:hidden"
          />
        </span>
      </div>
      <div className="container px-4">
        <div className="-mx-4 flex flex-wrap items-center">
          <div className="w-full px-4 lg:w-7/12 xl:w-8/12">
            <div className="ud-contact-content-wrapper">
              <div className="ud-contact-title mb-12 lg:mb-[150px]">
                <span className="mb-5 text-base font-semibold text-dark-900">
                  CONTACT US
                </span>
                <h2 className="text-[35px] font-semibold">
                  Let's talk about <br />
                  Love to hear from you!
                </h2>
              </div>
              <div className="mb-12 flex flex-wrap justify-between lg:mb-0">
                <div className="mb-8 flex w-[330px] max-w-full">
                  <div className="mr-6 text-[32px] text-dark-700">
                    <svg
                      width="29"
                      height="35"
                      viewBox="0 0 29 35"
                      className="fill-current"
                    >
                      <path d="M14.5 0.710938C6.89844 0.710938 0.664062 6.72656 0.664062 14.0547C0.664062 19.9062 9.03125 29.5859 12.6406 33.5234C13.1328 34.0703 13.7891 34.3437 14.5 34.3437C15.2109 34.3437 15.8672 34.0703 16.3594 33.5234C19.9688 29.6406 28.3359 19.9062 28.3359 14.0547C28.3359 6.67188 22.1016 0.710938 14.5 0.710938ZM14.9375 32.2109C14.6641 32.4844 14.2812 32.4844 14.0625 32.2109C11.3828 29.3125 2.57812 19.3594 2.57812 14.0547C2.57812 7.71094 7.9375 2.625 14.5 2.625C21.0625 2.625 26.4219 7.76562 26.4219 14.0547C26.4219 19.3594 17.6172 29.2578 14.9375 32.2109Z" />
                      <path d="M14.5 8.58594C11.2734 8.58594 8.59375 11.2109 8.59375 14.4922C8.59375 17.7188 11.2187 20.3984 14.5 20.3984C17.7812 20.3984 20.4062 17.7734 20.4062 14.4922C20.4062 11.2109 17.7266 8.58594 14.5 8.58594ZM14.5 18.4297C12.3125 18.4297 10.5078 16.625 10.5078 14.4375C10.5078 12.25 12.3125 10.4453 14.5 10.4453C16.6875 10.4453 18.4922 12.25 18.4922 14.4375C18.4922 16.625 16.6875 18.4297 14.5 18.4297Z" />
                    </svg>
                  </div>
                  <div>
                    <h5 className="mb-6 text-lg font-semibold">Our Location</h5>
                    <p className="text-base text-body-color">
                      401 Broadway, 24th Floor, Orchard Cloud View, London
                    </p>
                  </div>
                </div>
                <div className="mb-8 flex w-[330px] max-w-full">
                  <div className="mr-6 text-[32px] text-dark-700">
                    <svg
                      width="34"
                      height="25"
                      viewBox="0 0 34 25"
                      className="fill-current"
                    >
                      <path d="M30.5156 0.960938H3.17188C1.42188 0.960938 0 2.38281 0 4.13281V20.9219C0 22.6719 1.42188 24.0938 3.17188 24.0938H30.5156C32.2656 24.0938 33.6875 22.6719 33.6875 20.9219V4.13281C33.6875 2.38281 32.2656 0.960938 30.5156 0.960938ZM30.5156 2.875C30.7891 2.875 31.0078 2.92969 31.2266 3.09375L17.6094 11.3516C17.1172 11.625 16.5703 11.625 16.0781 11.3516L2.46094 3.09375C2.67969 2.98438 2.89844 2.875 3.17188 2.875H30.5156ZM30.5156 22.125H3.17188C2.51562 22.125 1.91406 21.5781 1.91406 20.8672V5.00781L15.0391 12.9922C15.5859 13.3203 16.1875 13.4844 16.7891 13.4844C17.3906 13.4844 17.9922 13.3203 18.5391 12.9922L31.6641 5.00781V20.8672C31.7734 21.5781 31.1719 22.125 30.5156 22.125Z" />
                    </svg>
                  </div>
                  <div>
                    <h5 className="mb-6 text-lg font-semibold">
                      How Can We Help?
                    </h5>
                    <p className="text-base text-body-color">
                      info@yourdomain.com
                    </p>
                    <p className="text-base text-body-color">
                      contact@yourdomain.com
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full px-4 lg:w-5/12 xl:w-4/12">
            <div
              className="wow fadeInUp rounded-lg bg-secondary-100 py-10 px-8 shadow-testimonial sm:py-12 sm:px-10 md:p-[60px] lg:p-10 lg:py-12 lg:px-10 2xl:p-[60px]"
              data-wow-delay=".2s
              "
            >
              <h3 className="mb-8 text-2xl font-semibold md:text-[26px]">
                Send us a Message
              </h3>
              <form>
                <div className="mb-6">
                  <label htmlFor="fullName" className="block text-xs text-900">
                    Full Name*
                  </label>
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Adam Gelius"
                    className="w-full border-0 border-b border-secondary-400 py-4 focus:border-dark-700 focus:outline-none"
                  />
                </div>
                <div className="mb-6">
                  <label htmlFor="email" className="block text-xs text-dark-900">
                    Email*
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="example@yourmail.com"
                    className="w-full border-0 border-b border-secondary-400 py-4 focus:border-dark-700 focus:outline-none"
                  />
                </div>
                <div className="mb-6">
                  <label htmlFor="phone" className="block text-xs text-dark-900">
                    Phone*
                  </label>
                  <input
                    type="text"
                    name="phone"
                    placeholder="+885 1254 5211 552"
                    className="w-full border-0 border-b border-secondary-400 py-4 focus:border-dark-700 focus:outline-none"
                  />
                </div>
                <div className="mb-6">
                  <label htmlFor="message" className="block text-xs text-dark-900">
                    Message*
                  </label>
                  <textarea
                    name="message"
                    rows="1"
                    placeholder="type your message here"
                    className="w-full resize-none border-0 border-b border-secondary-400 py-4 focus:border-dark-700 focus:outline-none"
                  ></textarea>
                </div>
                <div className="mb-0">
                  <button type="submit">
                    <a
                      href="#"
                      className="bg-success-600 inline-flex items-center justify-center rounded-[5px] py-3 px-6 text-center text-base font-medium text-secondary-100 hover:bg-opacity-90"
                    >
                      <span className="mr-[10px]">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          className="fill-current"
                        >
                          <path
                            d="M17.8125 16.6652H2.1875C1.69022 16.6652 1.21331 16.4677 0.861675 16.1161C0.510044 15.7644 0.3125 15.2875 0.3125 14.7902V5.20898C0.3125 4.7117 0.510044 4.23479 0.861675 3.88316C1.21331 3.53153 1.69022 3.33398 2.1875 3.33398H17.8125C18.3098 3.33398 18.7867 3.53153 19.1383 3.88316C19.49 4.23479 19.6875 4.7117 19.6875 5.20898V14.7902C19.6875 15.2875 19.49 15.7644 19.1383 16.1161C18.7867 16.4677 18.3098 16.6652 17.8125 16.6652ZM2.1875 4.58398C2.02174 4.58398 1.86277 4.64983 1.74556 4.76704C1.62835 4.88425 1.5625 5.04322 1.5625 5.20898V14.7902C1.5625 14.956 1.62835 15.115 1.74556 15.2322C1.86277 15.3494 2.02174 15.4152 2.1875 15.4152H17.8125C17.9783 15.4152 18.1372 15.3494 18.2544 15.2322C18.3717 15.115 18.4375 14.956 18.4375 14.7902V5.20898C18.4375 5.04322 18.3717 4.88425 18.2544 4.76704C18.1372 4.64983 17.9783 4.58398 17.8125 4.58398H2.1875Z"
                            fill="white"
                          ></path>
                          <path
                            d="M10.0016 10.643C9.63422 10.643 9.27406 10.5413 8.96093 10.3493L0.889055 5.44927C0.746501 5.36308 0.644027 5.22378 0.604175 5.06203C0.584443 4.98194 0.580678 4.89875 0.593097 4.8172C0.605516 4.73566 0.633875 4.65736 0.676555 4.58677C0.719234 4.51619 0.775399 4.4547 0.841842 4.40582C0.908284 4.35694 0.983704 4.32163 1.06379 4.30189C1.22554 4.26204 1.3965 4.28808 1.53905 4.37427L9.61093 9.28052C9.72906 9.35258 9.86475 9.3907 10.0031 9.3907C10.1415 9.3907 10.2772 9.35258 10.3953 9.28052L18.4641 4.37427C18.5342 4.33159 18.6121 4.30315 18.6933 4.29058C18.7745 4.278 18.8573 4.28154 18.9371 4.30098C19.0169 4.32042 19.0921 4.35539 19.1584 4.40389C19.2247 4.45239 19.2808 4.51347 19.3234 4.58365C19.3661 4.65382 19.3945 4.73172 19.4071 4.81288C19.4197 4.89405 19.4162 4.9769 19.3967 5.0567C19.3773 5.1365 19.3423 5.21169 19.2938 5.27797C19.2453 5.34426 19.1842 5.40034 19.1141 5.44302L11.0422 10.3493C10.7291 10.5413 10.3689 10.643 10.0016 10.643Z"
                            fill="white"
                          ></path>
                        </svg>
                      </span>
                      Send Message
                    </a>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
